import styled from "styled-components";

// Components
import SimpleLoading from "../../../components/common/SimpleLoading";

const LoadingTestResponse = ({ error }) => {

    return (
        <Container>
            {
                error ? (
                    <h1>
                        Hubo un error,
                        <br />
                        por favor, recarga la página e intenta de nuevo.
                    </h1>
                ) : (
                    <>
                        <SimpleLoading />
                        <h1>
                            Aguarda un instante,
                            <br />
                            Estamos procesando tu información.
                        </h1>
                    </>
                )
            }
        </Container>
    );
}

export default LoadingTestResponse;

const Container = styled.div`
    position: absolute;
    top: 55%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 480px;
    height: 500px;
    background-color: #fff;
    border-radius: 30px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 2rem;

    @media (width < 1000px) {
        width: 90%;
    }

    h1 {
        text-align: center;
        font-size: 24px;
        font-weight: 700;
        color: #b31d15;
    }
`